'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { Platform, Pressable, View } from 'react-native';
import { LinkCore } from './core';
function Link({ viewProps, ...props }) {
    return (_jsx(LinkCore, { ...props, Component: Platform.select({
            web: View,
            default: Pressable,
        }), componentProps: viewProps }));
}
export { Link };
//# sourceMappingURL=link.js.map